/**
 * Carte d'identité de Mon compte v2 (SPEC MC9) — maquette 17-compte (`.acct-head` : initiales,
 * prénom nom, « Membre depuis », e-mail). « Membre depuis » seulement si `CreationDate` existe dans
 * GET client/me ; pas de série « semaines d'affilée » (SPEC § 2.4 point 8 : pas de source validée).
 */
import { useFetchMe } from 'hooks/useApiQueries';
import { useUserContext } from 'providers/useUserContext';
import { fmtMonthYear, initials, toDate } from '../lib/format';

export function IdentityCard() {
  const { user: sessionUser } = useUserContext();
  const { data: me } = useFetchMe();
  const user = me ?? sessionUser;
  const since = toDate(user?.CreationDate);
  const name = [user?.FirstName, user?.LastName].filter(Boolean).join(' ');

  return (
    <div className="mmv2-card mmv2-acct-id">
      <div className="mmv2-acct-id__avatar" aria-hidden="true">
        {initials(user?.FirstName, user?.LastName)}
      </div>
      <div className="mmv2-acct-id__text">
        <p className="mmv2-acct-id__name">{name}</p>
        <p className="mmv2-small mmv2-muted mmv2-acct-id__meta">
          {since && since.getFullYear() > 1900 ? <span>Membre depuis {fmtMonthYear(since)}</span> : null}
          {user?.Email ? <span>{user.Email}</span> : null}
        </p>
      </div>
    </div>
  );
}
